import FlashMessage from '../index';
import baseTemplate from './index.html';
import header from '../partials/header.html';
import footer from '../partials/footer.html';

export default FlashMessage.extend({
  name: 'PresskitFlashMessage',
  template: header + baseTemplate + footer,
});



// WEBPACK FOOTER //
// ./src/js/components/flash-messages/presskit/index.js